/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateReleaseFormRequest } from '../models/CreateReleaseFormRequest';
import type { EditReleaseFormRequest } from '../models/EditReleaseFormRequest';
import type { GuestUrlDto } from '../models/GuestUrlDto';
import type { IdentityDocument } from '../models/IdentityDocument';
import type { InviteGuestUrlRequest } from '../models/InviteGuestUrlRequest';
import type { OnlyFansMessage } from '../models/OnlyFansMessage';
import type { ReleaseForm } from '../models/ReleaseForm';
import type { ReleaseFormList } from '../models/ReleaseFormList';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OfReleaseFormsService {
    /**
     * @returns IdentityDocument OK
     * @throws ApiError
     */
    public static uploadDocument({
        creatorId,
    }: {
        creatorId: number,
    }): CancelablePromise<IdentityDocument> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/uploadDocument',
            path: {
                'creatorId': creatorId,
            },
        });
    }
    /**
     * @returns GuestUrlDto OK
     * @throws ApiError
     */
    public static createGuestUrl({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: InviteGuestUrlRequest,
    }): CancelablePromise<GuestUrlDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/createGuestUrl',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ReleaseForm OK
     * @throws ApiError
     */
    public static createForm({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: CreateReleaseFormRequest,
    }): CancelablePromise<ReleaseForm> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/createForm',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns GuestUrlDto OK
     * @throws ApiError
     */
    public static editGuestName({
        creatorId,
        guestId,
        requestBody,
    }: {
        creatorId: number,
        guestId: number,
        requestBody: InviteGuestUrlRequest,
    }): CancelablePromise<GuestUrlDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/{guestId}/editGuest',
            path: {
                'creatorId': creatorId,
                'guestId': guestId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static toggleShow({
        creatorId,
        entityType,
        entityId,
    }: {
        creatorId: number,
        entityType: string,
        entityId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/{entityType}/{entityId}/toggleShow',
            path: {
                'creatorId': creatorId,
                'entityType': entityType,
                'entityId': entityId,
            },
        });
    }
    /**
     * @returns OnlyFansMessage OK
     * @throws ApiError
     */
    public static editReleaseForm({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: EditReleaseFormRequest,
    }): CancelablePromise<OnlyFansMessage> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/editReleaseForm',
            path: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Search for release forms
     * Query in the release forms to use when sending messages
     * @returns ReleaseFormList OK
     * @throws ApiError
     */
    public static getReleaseForms({
        creatorId,
        offset,
        filter,
        sort,
        order,
        query,
    }: {
        /**
         * The ID of the creator
         */
        creatorId: number,
        /**
         * The offset while using pagination
         */
        offset: number,
        /**
         * The filter to be used (all or pending)
         */
        filter: string,
        /**
         * The sort to be used (name or date)
         */
        sort: string,
        /**
         * The order to be used (desc or asc)
         */
        order: string,
        /**
         * The query parameter to search for
         */
        query: string,
    }): CancelablePromise<ReleaseFormList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/of-release-forms/{creatorId}/list',
            path: {
                'creatorId': creatorId,
            },
            query: {
                'offset': offset,
                'filter': filter,
                'sort': sort,
                'order': order,
                'query': query,
            },
        });
    }
}
